import { Navigate } from "react-router-dom"

/** Concierge lives under Settings; keep a short redirect for old bookmarks. */
export default function ConciergePage() {
  return <Navigate to="/settings?tab=concierge" replace />
}
